(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/sidebar/sidebar.tpl.html',
    '<ul class="nav nav-sidebar list-unstyled"><li class="nav-header"><a ui-sref="track" data-toggle="collapse" translate="sidebar.betotrack.dashboard"></a></li><li class="nav-header"><a data-toggle="collapse" data-target="#mapMenu"><span translate="sidebar.betotrack.maps"></span><i class="glyphicon glyphicon-chevron-right"></i></a></li></ul>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/sidebar/sidebar.tpl.js